import { persist } from "easy-peasy";
import AuthStore, { AuthModel } from "store/auth";
import ItemStore, { ItemModel } from "store/item";
import AirportStore, { IAirportModel } from "store/airport";
import SessionStore, { SessionModel } from "store/session";
import OrderResponseStore, { OrderResponseModel } from "store/orderResponse";
import CmsContentStore, { CmsContentModel } from "store/cmsContent";
import PaymentAdditionalDataStore, {
  PaymentAdditionalDataModel,
} from "store/paymentAdditionalData";

export interface StoreModel {
  auth: AuthModel;
  item: ItemModel;
  session: SessionModel;
  airports: IAirportModel;
  response: OrderResponseModel;
  cmsContent: CmsContentModel;
  paymentAdditionalData: PaymentAdditionalDataModel;
}

const Store: StoreModel = {
  auth: AuthStore,
  item: ItemStore,
  airports: persist(AirportStore, { storage: "localStorage" }),
  session: persist(SessionStore),
  response: persist(OrderResponseStore),
  cmsContent: CmsContentStore,
  // Intentionally NOT persisted (no `persist()`) — this must behave like a plain
  // in-memory state variable for the Payment session: it survives switching
  // between the Supplier/Customer tabs (both keep the app's easy-peasy store
  // mounted), but is explicitly cleared when the user leaves Payment for
  // another page (see clearPaymentAdditionalData usages), and never
  // resurrects itself after a full page reload the way localStorage would.
  paymentAdditionalData: PaymentAdditionalDataStore,
};

export default Store;
